import React from 'react';
import { BsGlobe } from 'react-icons/bs';
import { FaYoutube, FaTiktok, FaLinkedinIn } from 'react-icons/fa';

function Header() {
  const className =
    'rounded-md hover:scale-105 transitions flex-colo w-8 h-8 bg-main text-xs text-white';
  return (
    <div className="rounded-lg w-full mb-12 lg:mb-24 flex-btn">
      <img
        className="w-28 h-28 object-contain"
        src="/images/logo.png"
        alt="logo"
      />
      {/* social media */}
      <div className="flex gap-4">
        <a
          className={className}
          href="http://www.codemarketi.com"
          target="_blank"
          rel="noreferrer"
        >
          <BsGlobe />
        </a>
        <a
          className={className}
          href="https://www.youtube.com/@zpunet"
          target="_blank"
          rel="noreferrer"
        >
          <FaYoutube />
        </a>
        <a
          className={className}
          href="https://www.tiktok.com/@frontenddeveloperr"
          target="_blank"
          rel="noreferrer"
        >
          <FaTiktok />
        </a>
        <a
          className={className}
          href="https://www.linkedin.com/company/Codemarketi/"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </div>
  );
}

export default Header;
